import type { PublicItem, SectionKey } from "./types";

export interface SectionInfo {
  key: SectionKey;
  /** Shown in the top bar. */
  label: string;
  /** Shown under the progress bars. */
  short: string;
}

/** Config order: freedom (F), clarity (C), domain (D), gifts (G). */
export const SECTIONS: SectionInfo[] = [
  { key: "freedom", label: "Freedom", short: "Freedom" },
  { key: "clarity", label: "Clarity", short: "Clarity" },
  { key: "domain", label: "How you’re built", short: "Built" },
  { key: "gifts", label: "Gifts", short: "Gifts" },
];

export const sectionInfo = (key: SectionKey): SectionInfo => SECTIONS.find((s) => s.key === key) ?? SECTIONS[0]!;

export interface SectionProgress extends SectionInfo {
  /** 0..1: how far through this section the current question is. */
  fill: number;
  current: boolean;
}

/** Bars for the four sections, given the current question index (items.length = all done). */
export function sectionProgress(items: PublicItem[], index: number): SectionProgress[] {
  return SECTIONS.map((s) => {
    const positions = items.flatMap((item, i) => (item.section === s.key ? [i] : []));
    const first = positions[0] ?? 0;
    const count = positions.length;
    const done = positions.filter((i) => i < index).length;
    const current = count > 0 && index >= first && index < first + count;
    return { ...s, fill: count === 0 ? 0 : done / count, current };
  });
}
